import React from 'react';
import "../styles/Blog.css";

const ITCompanyBlog = () => {
  return (
    <div className="it-company-blog-container8">
      <article className="it-company-article8">
        <h1 className="blog-title8">
          Why we are the Best IT company in Salem: The Innovation Behind Our
          Success
        </h1>

        <img
          src="/images/bestitcompanyinsalem.png"
          alt=""
          className="blog-images"
        />

        <p className="blog-intro8">
          We are your digital growth partner. Here's what sets us apart as the
          Best IT company in Salem:
        </p>

        <section className="blog-section8">
          <h2 className="section-title8">1. Full-Stack Development Services</h2>
          <p className="section-content8">
            From web to mobile apps, we offer end-to-end development services
            using the latest technologies like:
          </p>
          <div className="tech-grid8">
            <div className="tech-item8">
              <h3 className="tech-title8">Frontend</h3>
              <p>React.js, Next.js</p>
            </div>
            <div className="tech-item8">
              <h3 className="tech-title8">Backend</h3>
              <p>Node.js, PHP</p>
            </div>
            <div className="tech-item8">
              <h3 className="tech-title8">Mobile</h3>
              <p>Flutter, React Native for cross-platform mobile apps</p>
            </div>
          </div>
          <p className="section-content8">
            Whether you are launching a startup or upgrading your company, our
            experienced team delivers scalable, secure, and digital solutions.
          </p>
        </section>

        <section className="blog-section8">
          <h2 className="section-title8">2. Website Design & Development</h2>
          <p className="section-content8">
            Looking for a professional website that truly represents your brand?
            Partner with us, our design team creates stunning, mobile-friendly,
            SEO-optimized websites using:
          </p>
          <ul className="feature-list8">
            <li className="feature-list-item8">Custom UI/UX design</li>
            <li className="feature-list-item8">WordPress</li>
            <li className="feature-list-item8">
              Fast-loading, responsive layouts
            </li>
            <li className="feature-list-item8">
              Integrated contact forms, chatbots, and booking systems
            </li>
          </ul>
        </section>

        <section className="blog-section8">
          <h2 className="section-title8">3. Mobile App Development</h2>
          <p className="section-content8">
            We deliver high-quality mobile app services, one of the many reasons
            we're recognized as the Best IT company in Salem. We build
            performance-oriented mobile apps for Android and iOS platforms. Our
            apps are known for:
          </p>
          <ul className="feature-list8">
            <li className="feature-list-item8">Seamless user experience</li>
            <li className="feature-list-item8">Bug-free performance</li>
            <li className="feature-list-item8">
              Push notifications and real-time features
            </li>
            <li className="feature-list-item8">Payment gateway integrations</li>
          </ul>
        </section>

        <section className="blog-section8">
          <h2 className="section-title8">
            4. Digital Marketing & SEO Services
          </h2>
          <p className="section-content8">
            Our high-quality digital marketing services are one of the key
            reasons clients recognize us as the leading IT company in Salem, we
            help businesses grow online through:
          </p>
          <ul className="feature-list8">
            <li className="feature-list-item8">
              Local SEO and Google My Business optimization
            </li>
            <li className="feature-list-item8">Social media marketing</li>
            <li className="feature-list-item8">
              PPC (Google Ads/Facebook Ads)
            </li>
            <li className="feature-list-item8">Email marketing</li>
          </ul>
        </section>

        <section className="cta-section8">
          <h2 className="cta-title8">Ready to Build the Future Together?</h2>
          <p className="cta-content8">
            If you're searching for the Best IT company in Salem, your search
            ends here. We're passionate about technology, dedicated to
            delivering quality, and focused on your business growth.
          </p>
          <p className="company-signature8">
            MPeoples Business Solution Pvt Ltd.,
          </p>
        </section>
      </article>
    </div>
  );
};

export default ITCompanyBlog;